import { keys } from 'lodash'
import { sanitizeText, createEmptyBlock } from '../util/draftUtils'
import TextConverter from './TextConverter'

const keyLevelMap = {
  'header-one': 1,
  'header-two': 2,
  'header-three': 3,
  'header-four': 4,
  'header-five': 5,
  'header-six': 6,
}

export default class HeaderConverter extends TextConverter {
  constructor() {
    super('header', keys(keyLevelMap))
  }

  appendAndGetBlocks(element = {}, context) {
    const { level = 6 } = element
    const hBlock = `h${level}`
    const blocksFromHTML = context.toDraftBlock(
      `<${hBlock}>${sanitizeText(element.content)}</${hBlock}>`,
      element,
      [createEmptyBlock(this.getDraftTypes()[level - 1])]
    )
    return context.appendBlock(blocksFromHTML.contentBlocks)
  }

  toAnsDataFromBlocks(contentState, [block]) {
    const result = super.toAnsDataFromBlocks(contentState, [block])
    return result
      ? {
          ...result,
          type: this.getAnsType(),
          level: keyLevelMap[block.getType()],
        }
      : null
  }
}
